import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const sportsSections = [
    { id: 'intro', name: 'खेल विभाग परिचय' },
    { id: 'functions', name: 'खेल विभाग के कार्य' },
    { id: 'achievements', name: 'उपलब्धियां' },
    { id: 'members', name: 'विभाग में कार्यरत सदस्य' }
];

const sportsContent = {
    intro: (
        <section>
            <p>
                महर्षि वाल्मीकि संस्कृत विश्वविद्यालय का खेल विभाग छात्रों को खेल और शारीरिक गतिविधियों में भाग लेने का अवसर प्रदान करता है।
                खेल विभाग का मुख्य उद्देश्य खेल भावना को बढ़ावा देना, प्रतिभा को निखारना और छात्रों के समग्र विकास में योगदान करना है ।
            </p>
        </section>
    ),
    functions: (
        <section>
            <ul>
                <li>
                    <strong>खेल और शारीरिक गतिविधि:</strong> विश्वविद्यालय खेल विभाग विभिन्न खेलों और शारीरिक गतिविधियों का आयोजन करता है,
                    जिसमें अंतर-महाविद्यालय प्रतियोगिताएं और कार्यक्रम शामिल हैं ।
                </li>
                <li>
                    <strong>खेल भावना और नेतृत्व:</strong> खेल विभाग खेल भावना, टीम वर्क और नेतृत्व कौशल को विकसित करने पर जोर देता है ।
                </li>
                <li>
                    <strong>स्वास्थ्य और फिटनेस:</strong> छात्रों को स्वास्थ्य और फिटनेस के बारे में जागरूकता बढ़ाने और स्वस्थ जीवनशैली को बढ़ावा देने में मदद करना है ।
                </li>
                <li>
                    <strong>उत्कृष्टता:</strong> खेल विभाग छात्रों को राष्ट्रीय और अंतर्राष्ट्रीय स्तर पर प्रतिस्पर्धा करने के लिए तैयार करता है ।
                </li>
            </ul>
        </section>
    ),
    achievements: (
        <section>
            <p>
                पिछले चार वर्षों से AIIU द्वारा राष्ट्रीय स्तर की प्रतियोगिताओं में छात्रों को प्रेषित किया जाता है।<br />
                इस वर्ष योग प्रतियोगिताओं में राष्ट्रीय स्तर पर कांस्य पदक प्राप्त किया।
            </p>
        </section>
    ),
    members: (
        <section>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead className="table-light">
                        <tr>
                            <th>क्रम. स.</th>
                            <th>सदस्य का नाम</th>
                            <th>पद</th>
                            <th>आधिकारिक ई-मेल</th>
                            <th>मोबाईल नं.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>डॉ. विनय गोपाल त्रिपाठी</td>
                            <td>खेल समन्वयक</td>
                            <td>sports@mvsu.ac.in</td>
                            <td>8076723202</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>2</td>
                            <td>श्री सिकन्दर लाल</td>
                            <td>DEO</td>
                            <td>Lalsikander123@gmail.com</td>
                            <td>9992158206</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </section>
    )
};

export default function SportsandGames() {
    const [activeTab, setActiveTab] = useState('intro');
    const [showSidebar, setShowSidebar] = useState(true);

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle button for mobile */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside className={`p-3 shadow d-flex flex-column bg-white ${showSidebar ? 'd-block' : 'd-none d-md-flex'} col-md-3`}>
                <h5 className="text-center fw-bold mb-3">खेल विभाग</h5>
                {sportsSections.map((section) => (
                    <p
                        key={section.id}
                        onClick={() => {
                            setActiveTab(section.id);
                            setShowSidebar(false);
                        }}
                        style={{
                            cursor: 'pointer',
                            padding: '10px',
                            borderRadius: '8px',
                            fontWeight: activeTab === section.id ? 'bold' : 'normal',
                            backgroundColor: activeTab === section.id ? '#77236b' : '#f8f9fa',
                            color: activeTab === section.id ? 'white' : 'black'
                        }}
                    >
                        {section.name}
                    </p>
                ))}
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                <h4 className="text-center mb-4 fw-bold" style={{ color: '#77236b' }}>
                    {sportsSections.find((s) => s.id === activeTab)?.name}
                </h4>
                {sportsContent[activeTab] || <p className="text-muted">कृपया एक अनुभाग चुनें।</p>}
            </main>
        </div>
    );
}
